export default class InputPassword extends HTMLElement {

    constructor() {
        super()
        this.input = this.querySelector('input')
    }

    connectedCallback() {

        const link = document.createElement("a")
        link.innerHTML = '<i class="ri-eye-line" aria-hidden="true"></i>'
        link.classList.add('opacity-25')

        this.appendChild(link)

        link.addEventListener('click', (e) => {
            e.preventDefault()
            if (this.input.getAttribute('type') === "password") {
                this.input.setAttribute('type', 'text')
                link.classList.remove('opacity-25')
            } else {
                this.input.setAttribute('type', 'password')
                link.classList.add('opacity-25')
            }
        })

    }

}